import { defineStore } from 'pinia';
import { ref } from 'vue';
import apiClient from '@/api/apiClient';
import type { EntityType } from '@/types/enums';

interface RecentActivity {
    tax_id_full: string;
    razao_social: string;
    viewed_at: string;
}

interface ActiveProfile {
    id: string;
    profileName: string;
    entity_type: EntityType;
    instances: any[]; // Assuming instances is an array
    default_for_person: boolean;
    default_for_company: boolean;
    createdAt: string;
    last_updated_at: string;
}

export const useDashboardStore = defineStore('dashboard', () => {
    const recentActivity = ref<RecentActivity[]>([]);
    const activeProfiles = ref<ActiveProfile[]>([]);
    const isLoading = ref(false);
    const hasLoaded = ref(false);

    async function fetchDashboardData() {
        if (isLoading.value) return;
        isLoading.value = true;
        const recentActivityPromise = apiClient.get('/dashboard/recent-activity');
        const activeProfilesPromise = apiClient.get('/dashboard/active-profiles');
        try {
            const [recentActivityResponse, activeProfilesResponse] = await Promise.all([
                recentActivityPromise,
                activeProfilesPromise,
            ]);
            recentActivity.value = recentActivityResponse;
            activeProfiles.value = activeProfilesResponse;
        } catch (error) {
            console.error('Failed to fetch dashboard data:', error);
            // In a real app, we would show a toast notification
        } finally {
            isLoading.value = false;
            hasLoaded.value = true;
        }
    }

    return {
        recentActivity,
        activeProfiles,
        isLoading,
        hasLoaded,
        fetchDashboardData
    };
});
